// extracted by mini-css-extract-plugin
export default {"controlWrapper":"ManageShareModal_controlWrapper__MPhId"};